import { createQueryKeys } from '@lukemorales/query-key-factory';
import { IS_ADMIN_FE } from 'common/constants/general-access-role.constants';
import { EQueryKeys } from 'common/enums/query-kyes.enum';
import { reportingPaymentsAdminService, reportingPaymentsService } from '../services/reporting.service';
import { TReportingPaymentsReqParams, TReportingPaymentsResData } from '../types/reporting.types';

export const reportingQueryKeys = createQueryKeys(EQueryKeys.ReportingPaymentsQueryKeys, {
  getPayments: (counterpartyGUID: string, params: TReportingPaymentsReqParams = {}) => ({
    queryKey: ['reporting-payments', counterpartyGUID, params],
    queryFn: (): Promise<TReportingPaymentsResData> => reportingPaymentsService(counterpartyGUID, params),
  }),
  getPayments_MultiRole: (counterpartyGUID: string, params: TReportingPaymentsReqParams = {}) => ({
    queryKey: ['reporting-payments', counterpartyGUID, params],
    queryFn: (): Promise<TReportingPaymentsResData> =>
      IS_ADMIN_FE ? reportingPaymentsAdminService(params) : reportingPaymentsService(counterpartyGUID, params),
  }),
});
